import React from 'react';

import { Box, Paper, Stack, type SxProps, type Theme, Typography } from '@mui/material';

interface Props {
  actions?: React.ReactNode;
  children: React.ReactNode;
  contentSx?: SxProps<Theme>;
  subtitle?: React.ReactNode;
  title: React.ReactNode;
  titleActions?: React.ReactNode;
}

export default function TabPanelShell({ actions, children, contentSx, subtitle, title, titleActions }: Props) {
  return (
    <Stack spacing={3}>
      <Stack
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Stack spacing={1}>
          <Typography fontWeight={700} variant="h2">
            {title}
          </Typography>
          {subtitle && (
            <Typography color="text.secondary" variant="body2">
              {subtitle}
            </Typography>
          )}
          {titleActions}
        </Stack>
        {actions && (
          <Stack alignItems="center" direction="row" justifyContent={{ xs: 'flex-start', md: 'flex-end' }} spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>

      <Paper variant="outlined">
        <Box sx={{ px: 3, py: 2, ...contentSx }}>{children}</Box>
      </Paper>
    </Stack>
  );
}
